import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";


export const getOverViewForAD = async (
  email: string,
  tenantName: string,
  bucket: string,
  filterPagination: string,
  computerName: string,
  computerEmail: string,
): Promise<Object | undefined> => {
  try {
    if (!email || !tenantName) return;
    let url = `${NGROK}/api/influxdb/eventtimeline?bucketName=${bucket}&timingMode=${filterPagination}&email=${email}`;
    url += "&limitNeeded=false";
    if (tenantName !== null) {
      url += `&tenantName=${tenantName}`;
    }
    if (computerEmail.length > 0) {
      url += `&isDeviceSpecific=true&computer_email=${computerEmail}`;
    }
    return await apiClient<Object>({
      method: "GET",
      url
    });
  } catch (error) {
    console.error("saveToken error:", error);
  }
};

export const getOverView = async (
  email: string,
  tenantName: string,
  bucket: string,
  filterPagination: string,
  computerName: string,
  computerId: string,
  key: string,
  fromDetails: boolean = false
): Promise<Object | undefined> => {
  try {
    if (!email || !tenantName) return;
    let url = `${NGROK}/api/influxdb/eventtimeline?bucketName=${bucket}&timingMode=${filterPagination}&email=${email}`;
    url += "&limitNeeded=false";
    if (tenantName !== null) {
      url += `&tenantName=${tenantName}`;
    }
    if (fromDetails) {
      url += `&isDeviceSpecific=true&deviceName=${computerName}`;
      key = computerName;
    }
    if (computerId) {
      url += `&computerId=${encodeURIComponent(computerId)}`;
    }
    return await apiClient<Object>({
      method: "GET",
      url
    });
  } catch (error) {
    console.error("saveToken error:", error);
  }
};


export const getRecentLoginData = async (
  email: string,
  tenantName: string,
  bucket: string,
  filterPagination: string,
  computerName: string,
  computerId: string,
  key: string,
  fromDetails: boolean = false
): Promise<Object | undefined> => {
  try {
    if (!email || !tenantName) return;
    let url = `${NGROK}/api/influxdb/recentLogin?bucketName=${bucket}&timingMode=${filterPagination}&email=${email}`;
    url += "&limitNeeded=false";
    if (tenantName !== null) {
      url += `&tenantName=${tenantName}`;
    }
    if (fromDetails) {
      url += `&isDeviceSpecific=true&deviceName=${computerName}&computerId=${computerId}`;
      key = computerName;
    }
    return await apiClient<Object>({
      method: "GET",
      url
    });
  } catch (error) {
    console.error("saveToken error:", error);
  }
};